import { COMPETITOR_CONFIG_OPTIONS } from '@constants';

import { Nullable } from './common';

interface CheckCompetitorCountProps {
  type: COMPETITOR_CONFIG_OPTIONS;
  competitorConfig: COMPETITOR_CONFIG_OPTIONS;
  competitorCount?: Nullable<number>;
  range: { MIN: number; MAX: number };
}

export const checkCompetitorCount = ({
  competitorConfig,
  competitorCount,
  type,
  range,
}: CheckCompetitorCountProps): boolean => {
  if (competitorCount !== undefined && competitorCount !== null) {
    if (competitorConfig === type && (competitorCount < range.MIN || competitorCount > range.MAX)) {
      return false;
    }

    return true;
  }

  return true;
};
